"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("../../../../utils");
var _editIcon = _interopRequireDefault(require("../../../../assets/svg/edit-icon.svg"));
var _constant = require("../../../../constant");
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _hooks = require("../../../../hooks");
var _styled = require("./styled");
var _experienceSlider = _interopRequireDefault(require("./experience-slider"));
var _leadership = _interopRequireDefault(require("./buttons/leadership"));
var _laboral = _interopRequireDefault(require("./buttons/laboral"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var ExperienceItem = function ExperienceItem(_ref) {
  var student = _ref.student,
    isOpen = _ref.isOpen,
    onClickEdit = _ref.onClickEdit,
    goToMyResume = _ref.goToMyResume,
    showModal = _ref.showModal,
    showProfile = _ref.showProfile,
    setShowModal = _ref.setShowModal,
    isEdit = _ref.isEdit,
    hasHighlight = _ref.hasHighlight;
  var _useModal = (0, _hooks.useModal)(),
    modalParams = _useModal.modalParams,
    setModalParams = _useModal.setModalParams;
  var handleClose = function handleClose() {
    return setShowModal(null);
  };
  var professionalExperiences = student.professionalExperiences.filter(function (experience) {
    return experience.activeLines === 1;
  });
  var otherExperiences = student.otherExperiences.filter(function (experience) {
    return experience.activeLines === 1;
  });
  var showEditProfessional = isEdit || !(0, _isEmpty.default)(professionalExperiences);
  var showEditOther = isEdit || !(0, _isEmpty.default)(otherExperiences);
  var handleExperience = function handleExperience(experience) {
    setModalParams(experience);
    setShowModal(_constant.modals.EXPERIENCE);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_styled.Container, null, /*#__PURE__*/_react.default.createElement(_styled.ContainerInner, null, /*#__PURE__*/_react.default.createElement(_styled.WrapperEdit, null, showEditProfessional && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isEdit && /*#__PURE__*/_react.default.createElement(_styled.EditButton, {
    onClick: function onClick() {
      return onClickEdit(_constant.routes.LEVEL_BULLETS_BUZZ, true);
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _editIcon.default,
    alt: "edit"
  })), /*#__PURE__*/_react.default.createElement(_styled.Title, {
    isEdit: isEdit
  }, "Work"))), Object.entries((0, _utils.sortExperiencesByCompany)(professionalExperiences)).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      company = _ref3[0],
      experiences = _ref3[1];
    return /*#__PURE__*/_react.default.createElement(_laboral.default, {
      key: company,
      company: company,
      experiences: experiences,
      isOpen: isOpen,
      toggleModal: handleExperience
    });
  }), /*#__PURE__*/_react.default.createElement(_styled.WrapperEdit, null, showEditOther && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isEdit && /*#__PURE__*/_react.default.createElement(_styled.EditButton, {
    onClick: function onClick() {
      return onClickEdit(_constant.routes.LEVEL_BULLETS_BUZZ, true);
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _editIcon.default,
    alt: "edit"
  })), /*#__PURE__*/_react.default.createElement(_styled.Title, {
    isEdit: isEdit
  }, "Leadership & Activities"))), (0, _utils.sortExperiencesByDate)(otherExperiences).map(function (experience) {
    return /*#__PURE__*/_react.default.createElement(_leadership.default, {
      key: experience.id,
      experience: experience,
      isOpen: isOpen,
      toggleModal: handleExperience
    });
  }))), /*#__PURE__*/_react.default.createElement(_experienceSlider.default, {
    onClose: handleClose,
    goToMyResume: goToMyResume,
    student: student,
    showModal: showModal,
    modalParams: modalParams,
    showProfile: showProfile,
    hasHighlight: hasHighlight
  }));
};
ExperienceItem.propTypes = {
  student: _utils.studentProps.isRequired,
  onClickEdit: _propTypes.default.func.isRequired,
  setShowModal: _propTypes.default.func.isRequired,
  goToMyResume: _propTypes.default.func.isRequired,
  isOpen: _propTypes.default.bool.isRequired,
  isEdit: _propTypes.default.bool.isRequired,
  showModal: _propTypes.default.string,
  showProfile: _propTypes.default.bool,
  hasHighlight: _propTypes.default.bool
};
ExperienceItem.defaultProps = {
  showModal: false,
  showProfile: false,
  hasHighlight: false
};
var _default = ExperienceItem;
exports.default = _default;